// Editable business details — replace the placeholders below with official company information.
export const SITE = {
  name: "CREDNOVA SERVICES PRIVATE LIMITED",
  short: "CREDNOVA",
  tagline: "Your Trusted Partner for Loan Assistance",
  email: "support@crednovaservices.in",
  phone: "+91 72890 31351",
  whatsapp: "917289031351",
  address: "[Registered Office Address], Mumbai, Maharashtra, India",
  hours: "Monday – Saturday · 10:00 AM – 6:30 PM IST",
};

export const COMPLIANCE_TEXT =
  "CREDNOVA SERVICES PRIVATE LIMITED is a loan assistance and facilitation service provider. We are not a bank, NBFC, or lender and do not provide loans directly. Loan approval is solely at the discretion of the respective bank or financial institution and is subject to their eligibility criteria and policies.";

export const IMAGES = {
  hero: "https://images.unsplash.com/photo-1623662063260-a461db100d3e?crop=entropy&cs=srgb&fm=jpg&q=85",
  about: "https://images.unsplash.com/photo-1772301685774-a4f0e81e032e?crop=entropy&cs=srgb&fm=jpg&q=85",
  agreement: "https://images.unsplash.com/photo-1672380135241-c024f7fbfa13?crop=entropy&cs=srgb&fm=jpg&q=85",
  handshake: "https://images.unsplash.com/photo-1549923746-c502d488b3ea?crop=entropy&cs=srgb&fm=jpg&q=85",
};
